module.exports = __webpack_public_path__ + "img/hr-green-carpet-grass-10.bbff0e9c.png";